import { useContext, useEffect } from 'react';
import { useParams, Params } from 'react-router-dom';

import { HeaderContext } from 'providers';
import { HeaderContextData, IRoute } from 'types';
import { HISTORY } from 'constants/routes';

const initialData: HeaderContextData = {
  current: { path: '', title: '' },
  history: [],
};

const replaceRouteParams = (history: IRoute[], params: Params) => {
  const paramsKeys = Object.keys(params);

  return history.map((item) => {
    let routePath = item.path;

    paramsKeys.forEach((param) => {
      if (routePath.includes(param)) {
        const value = params[param];
        if (value) {
          routePath = routePath.replace(`:${param}`, value);
        }
      }
    });

    return { ...item, path: routePath };
  });
};

const innerHeaderData = (
  params: Params,
  current?: IRoute
): HeaderContextData => {
  if (current) {
    const history = HISTORY[current.title];
    const containsParams =
      history.filter((item) => item.path.includes(':')).length > 0;

    return {
      current,
      history: containsParams ? replaceRouteParams(history, params) : history,
    };
  }

  return initialData;
};

export const useHeader = ({ current, history }: HeaderContextData) => {
  const params = useParams();
  const { setState } = useContext(HeaderContext);

  useEffect(() => {
    setState(innerHeaderData(params, current));
  }, [current, history]);
};
